import request from "@/utils/request";
// 添加质检设备
const addCheckDevice = (params) =>
  request.post("/laiHi/common/qualityTestingDevice", params);
// 根据质检员信息统计以质检设备数量
const getQualityCount = (params) =>
  request.post("/laiHi/common/countQualityTestingDevice", params);
export { addCheckDevice, getQualityCount };
